import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Zoom, Fab as Fab$1 } from '@mui/material';
import { theme, archerConstants } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import 'uuid/v4';
import { Icon } from '../Icon/Icon.js';
import { Typography } from '../Typography/Typography.js';
var _excluded = ["classes", "className", "color", "disabled", "disableFocusRipple", "disableRipple", "href", "onClick", "size", "variant", "title", "icon", "type", "sx"];
var fabSize = theme.spacing(5.5);
var styles = {
  fabCommon: {
    padding: 0,
    width: fabSize,
    minWidth: fabSize,
    height: fabSize,
    minHeight: fabSize,
    transition: 'all 0.2s ease',
    '&:hover, &:active, &:focus': {
      width: 'auto',
      height: 'auto',
      '& [class*="fabLabelText"]': {
        width: 'auto',
        opacity: 1,
        paddingLeft: 1.5,
        paddingRight: 1,
        paddingY: 0.5
      },
      '& [class*="fabIcon"]': {
        marginRight: 1.5
      }
    }
  },
  fabText: {
    width: 0,
    opacity: 0,
    overflow: 'hidden',
    lineHeight: '1.25',
    fontSize: '1rem',
    fontWeight: 700
  },
  fabPrimary: {
    backgroundColor: 'primary.main',
    color: 'background.paper',
    '&:hover': {
      backgroundColor: archerConstants.archerPrimaryButtonHover
    },
    '&:focus, &:active': {
      backgroundColor: archerConstants.archerPrimaryButtonActive
    },
    '&.Mui-disabled': {
      color: archerConstants.archerBackgroundPaper
    }
  },
  fabSecondary: {
    backgroundColor: 'background.paper',
    color: 'primary.main',
    border: '1px solid',
    borderColor: 'primary.main',
    '&:hover': {
      color: archerConstants.archerContrastRatioSafe,
      backgroundColor: archerConstants.archerButtonHover,
      border: "1px solid ".concat(archerConstants.archerContrastRatioSafe)
    },
    '&:focus, &:active': {
      color: archerConstants.archerContrastRatioSafe,
      backgroundColor: archerConstants.archerButtonActive,
      border: "1px solid ".concat(archerConstants.archerContrastRatioSafe)
    }
  },
  fabDestructive: {
    backgroundColor: 'background.paper',
    color: 'primary.main',
    border: 'none',
    '&:hover': {
      color: archerConstants.archerContrastRatioSafe,
      backgroundColor: archerConstants.archerButtonHover
    },
    '&:focus, &:active': {
      color: archerConstants.archerContrastRatioSafe,
      backgroundColor: archerConstants.archerButtonActive
    }
  }
};

var Fab = function Fab(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      color = _ref.color,
      disabled = _ref.disabled,
      disableFocusRipple = _ref.disableFocusRipple,
      _ref$disableRipple = _ref.disableRipple,
      disableRipple = _ref$disableRipple === void 0 ? true : _ref$disableRipple,
      href = _ref.href,
      onClick = _ref.onClick,
      size = _ref.size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'extended' : _ref$variant,
      title = _ref.title,
      icon = _ref.icon,
      type = _ref.type,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  var fabCommon = styles.fabCommon,
      fabPrimary = styles.fabPrimary,
      fabSecondary = styles.fabSecondary,
      fabDestructive = styles.fabDestructive,
      fabText = styles.fabText;

  var getTypeStyle = function getTypeStyle() {
    var style = undefined;

    switch (type) {
      case 'primary':
        style = fabPrimary;
        break;

      case 'secondary':
        style = fabSecondary;
        break;

      case 'destructive':
        style = fabDestructive;
        break;
    }

    return style;
  };

  return /*#__PURE__*/React.createElement(Zoom, {
    "in": true
  }, /*#__PURE__*/React.createElement(Fab$1, _extends({
    sx: [fabCommon, getTypeStyle(), sx],
    classes: classes,
    title: title,
    className: className,
    color: color,
    disabled: disabled,
    disableFocusRipple: disableFocusRipple,
    disableRipple: disableRipple,
    href: href,
    size: size,
    variant: variant,
    onClick: onClick,
    role: "button"
  }, rest), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    sx: [fabText, sx],
    className: "fabLabelText"
  }, title), /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    fontSize: "medium",
    className: "fabIcon"
  })));
};

Fab.displayName = 'Fab';
export { Fab };